
import React from "react";
import { connect } from "react-redux";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";

import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser,
        project: store.project
    };
})

class Links extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workstreams: [],
            openTag: false

        }

    }

    render() {
        const { dispatch, conversations, loggedUser, project, userWorkstreams } = this.props;
        const workstreams = this.props.workstreams ? this.props.workstreams : conversations.fields.workstreams;

        const handleSelectworkstreams = (value, action) => {
            if (action === "all") {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "workstreams", value });
            } else {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "workstreams", value: action !== "removed" ? [...conversations.fields.workstreams, value] : conversations.fields.workstreams.filter(c => c.value !== value.value) });
            };
        }

        const handleRenderOptionWorkstream = value => {
            return (
                <div class="taggedWorkstreamDetails">
                    <div class="workstreamStatusIndicator" style={{ background: `${value.color}` }}></div>
                    <div class="taggedWorkstreamContent">
                        <p>{value.label}</p>
                    </div>
                </div>
            );
        }

        const handleOpenTag = () => {
            this.setState({ ...this.state, openTag: true });
        }

        const handleRedirect = (workstream) => {
            dispatch({ type: "SET_TASKS_PREFILTERS", column: "workstream", filter: workstream.label });
            window.location.replace(`/account#/projects/${this.props.project.Selected.id}/processes/tasks`);
        }
        const user = loggedUser.data
        const leadId = project.Selected.leadId
        const isAdmin = user.userRole < 3 || user.id === leadId || (conversations.selected.id && conversations.selected.creator.id === user.id);
        return (
            <div class="formContainer workstreamConvoContainer">
                <label>Links:</label>
                <a class='note_workstream_tag' data-tooltip-id={`links-workstream-tag`} onClick={handleOpenTag}>
                    <i class="material-icons text-size22">sell</i>

                    <Tooltip id={`links-workstream-tag`} place="bottom" effect="solid" >
                        Tag to a workstream
                    </Tooltip>
                </a>
                <Select
                    includeSelectAll={true}
                    selectAllLabel={'All Workstreams'}
                    isMultiple={true}
                    isSearchable={true}
                    classes={{ options: `recipientOptions workstreamConvoOptions` }}
                    options={userWorkstreams}
                    placeholder="Search Workstreams"
                    onChange={handleSelectworkstreams}
                    iconOnly={true}
                    anchorEl={$('.note_workstream_tag')}
                    renderOption={handleRenderOptionWorkstream}
                    isOpen={this.state.openTag}
                    onBlur={() => { this.setState({ ...this.state, openTag: false }) }}
                    searchIcon={<i class="material-icons">search</i>}
                />

                {workstreams.length > 0 && workstreams.filter((v, i) => i < 3).map(value => {
                    // const userWorkstreams = this.state.workstreams
                    return (
                        <div>
                            {(userWorkstreams.map(w => w.value).indexOf(value.value) > -1 || isAdmin) ?
                                <div class={`taggedWorkstreamDetails active`} onClick={() => handleRedirect(value)}>
                                    <div class="workstreamStatusIndicator" style={{ background: `${value.color}` }}></div>
                                    <div class="taggedWorkstreamContent">
                                        <p>{value.label.length > 24 ? value.label.substring(0, 24) + "..." : value.label}</p>
                                    </div>
                                </div> :
                                <div class="taggedWorkstreamDetails noLink">
                                    <div class="workstreamStatusIndicator" style={{ background: `${value.color}` }}></div>
                                    <div class="taggedWorkstreamContent">
                                        <p>{value.label.length > 24 ? value.label.substring(0, 24) + "..." : value.label}</p>
                                    </div>
                                </div>

                            }

                        </div>

                    )
                })}

                {workstreams.length > 3 &&
                    <React.Fragment>
                        <span data-tooltip-id={`tooltip_selected_notes_workstream`}>+{workstreams.length - 3} </span>
                        <Tooltip id={`tooltip_selected_notes_workstream`} place="bottom" effect="solid" >
                            {workstreams.filter((f, i) => i >= 3).map(s => {
                                return (
                                    <div>{s.label}</div>
                                )
                            }
                            )}
                        </Tooltip>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default Links;